import { useId, useState, type ReactElement, type ReactNode } from 'react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from './dropdown-menu';

export type ActionMenuOption<T extends string = string> = { icon?: ReactNode; label: string; value: T };

export function CustomActionMenu<T extends string>({ ariaLabel, contentClassName, disabled = false, onSelect, options, trigger }: {
  ariaLabel: string;
  contentClassName?: string;
  disabled?: boolean;
  onSelect: (value: T) => void;
  options: ReadonlyArray<ActionMenuOption<T>>;
  trigger: (input: { menuId: string; open: boolean; toggle: () => void }) => ReactElement;
}) {
  const id = useId();
  const [open, setOpen] = useState(false);
  return (
    <DropdownMenu onOpenChange={setOpen} open={open}>
      <DropdownMenuTrigger disabled={disabled} render={trigger({ menuId: `${id}-menu`, open, toggle: () => setOpen((current) => !current) })} />
      <DropdownMenuContent aria-label={ariaLabel} className={contentClassName} id={`${id}-menu`} side="top">
        {options.map((option) => <DropdownMenuItem key={option.value} onClick={() => onSelect(option.value)}>{option.icon}{option.label}</DropdownMenuItem>)}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
